export function interactionLeadLocalPart(email: string | null | undefined): string | undefined {
  const t = typeof email === "string" ? email.trim() : "";

  if (!t) return undefined;
  const at = t.indexOf("@");

  if (at <= 0) return t;
  const local = t.slice(0, at).trim();

  return local || undefined;
}
